require([
    'services',
    'jquery',
    'semantic',
    'ch_semantic_wishlist',
    'ch_modal_window',
    'ch_header',
    'ch_semantic_responsive'
], function () {

    $('.ui.checkbox').checkbox();

    // Newsletter email capture
    CH.semantic_form_validation = true;
    CH.validate('form_CaptureEmail', {
        submitHandler: function (form) {

            $form = $(form);
            $form.addClass('loading');
            $.ajax({
                type: 'POST',
                url: form.action,
                data: $form.serialize(),
                xhrFields: {
                    withCredentials: true,
                },
                success: function (res) {

                    $form.removeClass('loading');

                    if (res.success) {
                        swal({
                            title: $form.data('success-message') || 'Thank You for subscribing!',
                            type: 'success',
                            confirmButtonText: 'OK',
                            closeOnConfirm: true,
                        }, function () {

                            var destination = $form.data('success-destination');

                            window.location = destination || window.location;

                        });

                    } else if (res.error) {
                        swal('Sorry, there was a problem submitting your email address', res.error, 'error');
                    }

                },
            });

        },
    });

});
